import React, { useMemo, useState } from 'react';
// import ScaleArrow from 'components/ScaleArrow';

export default function AquaMenuItem({
  // scenes,
  scene,
  onSelect,
  currentPano,
  setOpenMobileMenu,
  setIsOpenTopviewSubmenu,
  setIsOpenMikaTopviewSubmenu,
  isOpenMikaTopviewSubmenu,
  isOpenTopviewSubmenu,
  isTopviewSub,
  onPDFClick,
  oncloseModal,
  onDropdownToggle,
  showDropdown,
  disableClick = false,
  isNhaMauSubmenu = false,
  useHoverForDropdown = false,
  onMenuClose,
}) {
  const [hover, setHover] = useState(null);

  // const hoverImage = useMemo(
  //   () => scenes.find((item) => item._id === scene._id),
  //   [scenes, scene]
  // );

  const isMobile = useMemo(() => window.innerWidth < 1023, []);

  const handleClick = (e) => {
    e.stopPropagation();

    // If clicks are disabled (e.g., for NHÀ MẪU submenus), don't do anything
    // if (isNhaMauSubmenu) {
    //   return;
    // }

    console.log('Clicked on scene:', scene);

    oncloseModal && oncloseModal();

    // Xử lý PDF click
    if (scene.type === 'PDF' && scene.pdfFile) {
      if (isMobile) {
        // Trên mobile: mở PDF trong tab mới luôn
        window.open(`/pdf/${scene.pdfFile.filename}`, '_blank');
      } else {
        // Trên desktop: sử dụng modal như cũ
        onPDFClick && onPDFClick(scene);
      }
      onMenuClose && onMenuClose(); // Close menu after PDF action
      return;
    }

    // Logic cũ cho mobile topview
    if (
      isMobile &&
      (scene.id === 'topview' ||
        scene.id === 'mika-topview' ||
        scene.id === 'jasari-scene')
    ) {
      if (scene.id === 'topview') {
        setIsOpenTopviewSubmenu(!isOpenTopviewSubmenu);
        setIsOpenMikaTopviewSubmenu(false);
      }

      if (scene.id === 'mika-topview') {
        setIsOpenMikaTopviewSubmenu(!isOpenMikaTopviewSubmenu);
        setIsOpenTopviewSubmenu(false);
      }

      if (scene.id === 'jasari-scene') {
        console.log(isOpenTopviewSubmenu);
        setIsOpenTopviewSubmenu(!isOpenTopviewSubmenu);
        setIsOpenMikaTopviewSubmenu(false);
      }
    } else {
      // Logic cũ cho desktop/normal scenes
      if (
        scene.id === 'topview' ||
        scene.id === 'mika-topview' ||
        scene.id === 'jasari-scene'
      ) {
        scene.id === 'jasari-scene' &&
          onSelect(scene.groupId, 'jasari-scene-18-33');

        scene.id === 'topview' && onSelect(scene.groupId, 'topview-tang-27');

        scene.id === 'mika-topview' &&
          onSelect(scene.groupId, 'mika-topview-tang-27');
      } else {
        // Normal scene selection

        console.log('Navigating to scene:', scene);
        onSelect(scene.groupId || 'welcome', scene.id);
      }

      if (isMobile) {
        isOpenTopviewSubmenu && setIsOpenTopviewSubmenu(false);
        isOpenMikaTopviewSubmenu && setIsOpenMikaTopviewSubmenu(false);
      }

      setOpenMobileMenu && setOpenMobileMenu();
      onMenuClose && onMenuClose(); // Close menu after successful navigation
    }
  };

  const handleMenuItemClick = (e) => {
    // If clicks are disabled (e.g., for NHÀ MẪU submenus), don't do anything
    if (disableClick) {
      e.stopPropagation();
      return;
    }

    // For level 2+ menus with sub-items on desktop with hover enabled, don't toggle on click
    if (
      (scene.id === 'topview' ||
        scene.id === 'mika-topview' ||
        scene.id === 'jasari-scene') &&
      onDropdownToggle &&
      !useHoverForDropdown
    ) {
      e.stopPropagation();
      onDropdownToggle();
      return;
    }

    // For other items, use the original click handler
    handleClick(e);
  };

  return (
    <div
      className={`menu-items-aqua__scenes-item primeStyle ${
        currentPano?.id === scene.id ? 'primeCurrentScene' : ''
      } ${
        scene.id === 'jasari-scene' ||
        scene.id === 'topview' ||
        scene.id === 'mika-topview'
          ? 'position-relative'
          : ''
      } ${scene.type === 'PDF' ? 'pdf-menu-item' : ''} ${
        showDropdown ? 'dropdown-open' : ''
      } ${disableClick ? 'disabled-click' : ''} ${
        isNhaMauSubmenu ? 'nha-mau-item' : ''
      }`}
      onMouseOver={() => {
        setHover(scene.order);
      }}
      onMouseLeave={() => {
        setHover(null);
      }}
      onClick={handleMenuItemClick}
    >
      {!isMobile && (
        <>
          <p
            className={`menu-items-aqua__scenes-item-title primeStyle ${
              hover === scene.order || currentPano.id === scene.id
                ? 'hovering'
                : ''
            } ${
              scene.id === 'topview' ||
              scene.id === 'mika-topview' ||
              scene.id === 'jasari-scene'
                ? 'plus-sign'
                : ''
            } ${scene.type === 'PDF' ? 'pdf-title' : ''}`}
          >
            {scene.type === 'PDF' && (
              <i className="fa fa-file-pdf-o pdf-icon"></i>
            )}
            {scene.title}
          </p>

          {/* {(scene.id === 'topview' ||
            scene.id === 'mika-topview' ||
            scene.id === 'jasari-scene') && (
            <ScaleArrow
              fontSize={12}
              color={'black'}
              rotate={showDropdown ? -90 : 180}
            />
          )} */}
        </>
      )}

      {isMobile && (
        <div className="menu-items-aqua__scenes-item-container">
          <p
            className={`menu-items-aqua__scenes-item-title primeStyle ${
              hover === scene.order || currentPano?.id === scene.id
                ? 'hovering'
                : ''
            } ${isTopviewSub ? 'sub-translateX' : ''} ${
              scene.type === 'PDF' ? 'pdf-title' : ''
            }`}
          >
            {/* {scene.type === 'PDF' && (
              <>
                <i className="fa fa-file-pdf-o pdf-icon"></i>
                <i className="fa fa-external-link mobile-external-icon"></i>
              </>
            )}

            {scene.id === 'jasari-scene' &&
              (isOpenTopviewSubmenu ? (
                <i className="fa fa-minus"></i>
              ) : (
                <i className="fa fa-plus"></i>
              ))}

            {scene.id === 'topview' &&
              (isOpenTopviewSubmenu ? (
                <i className="fa fa-minus"></i>
              ) : (
                <i className="fa fa-plus"></i>
              ))}

            {scene.id === 'mika-topview' &&
              (isOpenMikaTopviewSubmenu ? (
                <i className="fa fa-minus"></i>
              ) : (
                <i className="fa fa-plus"></i>
              ))} */}

            {/* {isTopviewSub && <span className="horizontal-line"></span>} */}
            {scene.title}
          </p>

          {/* {scene.id === 'jasari-scene' && (
            <ScaleArrow
              fontSize={12}
              color={'white'}
              rotate={isOpenTopviewSubmenu ? -90 : 180}
            />
          )}

          {scene.id === 'topview' && (
            <ScaleArrow
              fontSize={12}
              color={'white'}
              rotate={isOpenTopviewSubmenu ? -90 : 180}
            />
          )}

          {scene.id === 'mika-topview' && (
            <ScaleArrow
              fontSize={12}
              color={'white'}
              rotate={isOpenMikaTopviewSubmenu ? -90 : 180}
            />
          )} */}
        </div>
      )}

      {/* {!isMobile && scene.id !== 'topview' && scene.type !== 'PDF' && (
        <div
          className="menu-items-aqua__scenes-item-image"
          style={{ opacity: hover === scene.order ? 1 : 0 }}
        >
          <img src={hoverImage?.previewImgUrl} alt={hoverImage?.title} />
          <div className="menu-items-aqua__scenes-item-imgTitle">
            <p> {scene.title}</p>
          </div>
        </div>
      )} */}

      {/* Hiển thị PDF preview khi hover trên desktop */}
      {!isMobile && scene.type === 'PDF' && (
        <div
          className="menu-items-aqua__scenes-item-pdf-preview"
          style={{ opacity: hover === scene.order ? 1 : 0 }}
        >
          <div className="pdf-preview-container">
            <i className="fa fa-file-pdf-o pdf-preview-icon"></i>
            <div className="pdf-preview-info">
              <p className="pdf-preview-title">{scene.title}</p>
              <p className="pdf-preview-subtitle">Click để xem PDF</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
